import { render, staticRenderFns } from "./MarginControlTable.vue?vue&type=template&id=8ce5250c&"
import script from "./MarginControlTable.vue?vue&type=script&lang=js&"
export * from "./MarginControlTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports